import { Inertia } from '@inertiajs/inertia';

const config = {
  current_lang: 'lv',
  autoclear_cookies: true,                   // default: false
  page_scripts: true,                        // default: false
  // autorun: false,                            // default: true

  // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
  // delay: 0,                               // default: 0
  // auto_language: '',                      // default: null; could also be 'browser' or 'document'
  // force_consent: false,                   // default: false
  // hide_from_bots: false,                  // default: false
  // remove_cookie_tables: false             // default: false
  // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
  // cookie_expiration: 182,                 // default: 182 (days)
  // cookie_necessary_only_expiration: 182   // default: disabled
  // cookie_domain: location.hostname,       // default: current domain
  // cookie_path: '/',                       // default: root
  // cookie_same_site: 'Lax',                // default: 'Lax'
  // use_rfc_cookie: false,                  // default: false
  // revision: 0,                            // default: 0

  onFirstAction: function (user_preferences, cookie) {
    // callback triggered only once on the first accept/reject action
  },

  onAccept: function (cookie) {
    // callback triggered on the first accept/reject action, and after each page load
  },

  onChange: function (cookie, changed_categories) {
    // callback triggered when user changes preferences after consent has already been given
  },

  languages: {
    'lv': {
      consent_modal: {
        title: 'Mēs izmantojam sīkdatnes!',
        description: 'Lai nodrošinātu pilnvērtīgu vietnes darbību, mēs izmantojam sīkdatnes. Statistikas sīkdatnes tiks ieslēgtas tikai pēc Jūsu piekrišanas. <button type="button" data-cc="c-settings" class="cc-link">Pielāgota izvēle</button>',
        primary_btn: {
          text: 'Atļaut visas',
          role: 'accept_all'              // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Tikai nepieciešamās',
          role: 'accept_necessary'        // 'settings' or 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Sīkdatņu iestatījumi',
        save_settings_btn: 'Saglabāt izvēli',
        accept_all_btn: 'Atļaut visas',
        reject_all_btn: 'Aizliegt visas',
        close_btn_label: 'Aizvērt',
        cookie_table_headers: [
          {col1: 'Nosaukums'},
          {col2: 'Domēns'},
          {col3: 'Derīgums'},
          {col4: 'Apraksts'}
        ],
        blocks: [
          {
            title: 'Sīkdatņu izmantošana',
            description: 'Lai nodrošinātu vietnes darbību un padarītu to ērtāk izmantojamu, mēs izmantojam sīkdatnes. Jūs varat atļaut vai aizliegt jebkuras sīkdatņu kategorijas izmantošanu, izņemot obligāti nepieciešamās sīkdatnes. Lai uzzinātu vairāk par sikdatnēm un datu aizsardzību, iepazīstieties ar mūsu <a href="https://izglitiba.daugavpils.lv/Media/Default/normativie-dokumenti/privatuma_politika.pdf" class="cc-link">privātuma politiku</a>.'
          }, {
            title: 'Obligāti nepieciešamās sīkdatnes',
            description: 'Šīs sīkdatnes ir obligāti nepieciešamas pilnvērtīgai vietnes darbībai.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
            },
            cookie_table: [             // list of all expected cookies
              {
                col1: 'XSRF-TOKEN',       // match all cookies starting with "_ga"
                col2: 'plans.daugavpils.edu.lv',
                col3: '2 stundas',
                col4: 'nodrošina vietnes formu aizsardzību',
                is_regex: true
              },
              {
                col1: 'cc_cookie',
                col2: 'plans.daugavpils.edu.lv',
                col3: '6 mēneši',
                col4: 'glabā informāciju par sīkdatņu iestatījumiem',
              },
              {
                col1: 'pasakumi_session',
                col2: 'plans.daugavpils.edu.lv',
                col3: '2 stundas',
                col4: 'nodrošina vietnes administratora darbu',
              }
            ]
          }, {
            title: 'Statistikas sīkdatnes',
            description: 'Šīs sīkdatnes vāc informāciju par lapu apmeklējumiem un izmantotajām saitēm. Apkopotā informācija ir anonimizēta un neļauj identificēt konkrētus vietnes apmeklētājus.',
            toggle: {
              value: 'analytics',     // your cookie category
              enabled: false,
              readonly: false
            },
            cookie_table: [             // list of all expected cookies
              {
                col1: '_pk_id.*',       // match all cookies starting with "_ga"
                col2: 'plans.daugavpils.edu.lv',
                col3: '13 mēneši',
                col4: 'glabā lapas apmeklētāja identifikatoru',
                is_regex: true
              },
              {
                col1: '_pk_ses.*',
                col2: 'plans.daugavpils.edu.lv',
                col3: '30 minūtes',
                col4: 'īslaicīgi glabā informāciju par lapas apmeklējumu',
              }
            ]
          }, {
            title: 'Plašāka informācija',
            description: 'Ja rodas jautājumi par privātuma politiku un sīkdatņu izmantošanu, <a class="cc-link" href="https://izglitiba.daugavpils.lv/kontakti">sazinieties ar mums</a>.',
          }
        ]
      }
    }
  }
}

Inertia.on('navigate', (event) => {
  var _paq = window._paq || null;
  if (!_paq) return;

  _paq.push(['setReferrerUrl', location.href]);
  _paq.push(['setCustomUrl', '/' + event.detail.page.url]);
  _paq.push(['setDocumentTitle', document.title]);

  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
})

window.addEventListener('load', function () {
  var cc = initCookieConsent();
  cc.run(config);
});
